import { PercentageValueConverter } from '../../../../converters/percentage';
import { NumberValueConverter } from '../../../../converters/number';
import { FilesizeValueConverter } from '../../../../converters/filesize';
import { TimeValueConverter } from '../../../../converters/time';
import { FieldColorValueConverter } from '../../../../converters/field-color';
import { JoinValueConverter } from '../../../../converters/join';
import { JsonValueConverter } from '../../../../converters/json';
import { MilitaryTimeValueConverter } from '../../../../value-converter/military-time-value-converter';

const percentageConverter = new PercentageValueConverter();
const numberConverter = new NumberValueConverter();
const filesizeConverter = new FilesizeValueConverter();
const timeConverter = new TimeValueConverter();
const fieldColorConverter = new FieldColorValueConverter();
const joinConverter = new JoinValueConverter();
const jsonConverter = new JsonValueConverter();
const militaryTimeConverter = new MilitaryTimeValueConverter();

export const formatPercentage = (value) => percentageConverter.toView(value);
export const formatNumber = (value, format = '0.[000]') =>
    numberConverter.toView(value, format);
export const formatFilesize = (value) => filesizeConverter.toView(value);
export const formatTime = (value, format = '00:00:00') =>
    timeConverter.toView(value, format);
export const getFieldColorStyle = (value, field) => {
    const styleStr = fieldColorConverter.toView(value, field);
    if (!styleStr) {
        return undefined;
    }
    const match = styleStr.match(/color:\s*([^;]+)/);
    return match ? { color: match[1].trim() } : undefined;
};
export const formatJoin = (array) => joinConverter.toView(array);
export const formatJson = (obj) => jsonConverter.toView(obj);
export const formatMilitaryTime = (str) => militaryTimeConverter.toView(str);

export const shrinkValue = (value, maxContentLength) => {
    if (typeof value === 'string' && maxContentLength) {
        if (value.length > maxContentLength + 3) {
            const stripped = value.replace(/(<([^>]+)>)/gi, '');
            return stripped.substr(0, maxContentLength) + ' … ';
        }
    }
    return value;
};
